import * as React from 'react';

interface ContentDisplayProps {
  label: string;
  content: React.ReactNode;
  className?: string;
  containerClassName?: string;
  bottomComponents?: React.ReactNode;
  hint?: string;
}

export function ContentDisplay({
  className,
  label,
  containerClassName,
  bottomComponents,
  hint,
  content,
}: ContentDisplayProps) {
  return (
    <div className="space-y-1.5">
      <div
        className={`relative w-full rounded-2xl border border-border-tertiary bg-surfaces-bg-primary ${containerClassName}`}
      >
        <label className="absolute -top-2 left-3 !text-small bg-surfaces-bg-primary px-2 text-text-tertiary">
          {label}
        </label>
        <div className={`px-4 py-6 text-text-primary ${className}`}>{content}</div>
        {bottomComponents && <div className="px-4 pb-4 mt-2">{bottomComponents}</div>}
      </div>
      {hint && <p className="text-small text-text-tertiary ml-4">{hint}</p>}
    </div>
  );
}
